import styled from 'styled-components/macro'

export const Wrapper = styled.div``
export const LoadingMessage = styled.div``
export const LoadingWrapper = styled.div``
export const TextWrapper = styled.div``
export const SelectWrapper = styled.div``
export const LoaderContainer = styled.div<{ disabled?: boolean }>``
